<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="attrValueForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field>
          <mat-label>Valeur</mat-label>
          <input matInput placeholder="" type="text" required formControlName="value" />
          <mat-error>
            <span *ngIf="f('value').hasError('required')">Veuillez saisir une valeur</span>
          </mat-error>
        </mat-form-field>

      </div>
      <div class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Valider" type="submit"
          [disabled]="formSubmitting">
          Valider
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close appTooltip="Annuler" (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
